import CostPoolScale from './index.vue';

export default CostPoolScale;
